<generic-search-page PageTitle="Quotes" [filters]="filterCategories" [SearchForRows]="searchFn" [EditRow]="editFn" [SearchHistoryType]="searchHistoryType">
  <div class="pull-right" page-controls>
  </div>

  <quote-search-results results-grid [quotes]="SearchPageComponent()?.data()" (onEdit)="SearchPageComponent()?.edit($event)"
    (sortChanged)="SearchPageComponent()?.onSortChange($event)"></quote-search-results>
</generic-search-page>